<template>
    <b-card class="mt-3" v-if="items.length" body-class="py-3">
        <b-row>
            <b-col cols="auto">
                <b-button :variant="selectedItemsCount === items.length ? 'primary' : 'outline'"
                          class="btn-rounded"
                          @click="handleSelectAll"
                          :disabled="bulkActionRunning">
                    <i class="fas fa-check" v-if="selectedItemsCount === items.length"></i>
                    Select All
                </b-button>
                <b-button variant="outline"
                          class="btn-rounded"
                          @click="handleUnselectAll"
                          :disabled="bulkActionRunning">
                    Unselect All
                </b-button>
                <div class="d-inline-block" v-if="bulkActionRunning">
                    <div class="d-flex align-items-center">
                        <pulse-loader :loading="bulkActionRunning"
                                      size="10px"
                                      color="#00C0F4"
                                      class="mx-2"/>
                        <span>Please Wait</span>
                    </div>
                </div>
            </b-col>
            <b-col cols="auto" v-if="menuOptionsVisible" class="ml-auto">
                <slot name="menuSlot"></slot>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
  import PulseLoader from 'vue-spinner/src/PulseLoader';

  export default {
    props: ['items', 'bulkActionRunning', 'value', 'optionsAlwaysVisible'],

    methods: {
      handleSelectAll: function () {
        const selection = {};
        this.items.forEach(item => selection[item.id] = true);
        this.$emit('input', selection);
      },

      handleUnselectAll: function () {
        const selection = {};
        Object.keys(this.value).forEach(k => selection[k] = false);
        this.$emit('input', selection);
      },
    },

    computed: {
      menuOptionsVisible() {
        if (this.optionsAlwaysVisible) {
          return true
        }

        return this.selectionMode
      },

      selectedItems: function () {
        const itemIds = Object.keys(this.value).filter(itemId => this.value[itemId] === true);
        if (itemIds.length > 0) {
          return itemIds.map(itemId => {
            return this.items.find(item => item.id === itemId)
          })
        }
        return [];
      },

      selectedItemsCount: function () {
        return this.selectedItems.length;
      },

      selectionMode: function () {
        return this.selectedItemsCount > 0;
      }
    },

    components: {PulseLoader}
  }
</script>